import React from 'react';
import classnames from 'classnames';
import styles from './swipe-indicator.module.scss';

export type SwipeIndicatorProps = {
  value: number;
  max?: number;
  className?: string;
};

export const SwipeIndicator: React.FC<SwipeIndicatorProps> = ({ className, value, max = 100 }) => (
  <progress
    max={max}
    value={value}
    className={classnames(styles.swipeBar, className)}
    aria-hidden="true"
    data-testid="swipeindicator-component"
  />
);
